/**
 * @file board-types.ts
 * @description Общие типы доски заказов и возвратов (phase10.5; phase19.31 —
 * доска разбита на части по правилу «компонент ≤200 строк»).
 */

import type { OrderPipelineWithStagesDto } from "../../../lib/api-orders";
import type { ReturnPipelineWithStagesDto } from "../../../lib/api-returns";

/** Что на доске: заказы или возвраты (`?type=` в адресе). */
export type BoardType = "orders" | "returns";

export type OrderStageRow = OrderPipelineWithStagesDto["stages"][number];
export type ReturnStageRow = ReturnPipelineWithStagesDto["stages"][number];
/** Стадии заказов и возвратов устроены одинаково — колонка рисует обе. */
export type StageRow = OrderStageRow | ReturnStageRow;

/** Тип доски из адреса; по умолчанию — заказы. */
export function readBoardType(value: string | null): BoardType {
  return value === "returns" ? "returns" : "orders";
}

/** Подписи типов доски — для вкладок и заголовка. */
export const BOARD_TYPE_META: Record<BoardType, { tab: string; title: string; empty: string }> = {
  orders: { tab: "Заказы", title: "Доска заказов", empty: "Воронка заказов не настроена" },
  returns: { tab: "Возвраты", title: "Доска возвратов", empty: "Воронка возвратов не настроена" },
};

/** Цвет точки стадии без цвета магазина — нейтральный тон темы. */
export const STAGE_DOT_FALLBACK = "var(--status-neutral-dot, #9e9483)";
